// These colorSets are to be used inside the pinRenderer instead of the one from ui-components
export const colorSets = {
  disabled: {
    strokeSubjacent: '#C2C7D6',
  },
  active: {
    on: '#4E7FFF',
  },
  unsupported: {
    fill: '#FFF5E5',
    stroke: '#FFB94D',
    on: '#995D00',
  },
};
